import { createAsyncThunk } from "@reduxjs/toolkit";
import watcherApi from "../../api/watcherApi";

const PREFIX = "watcher_r2Files";

export const fetchR2Buckets = createAsyncThunk(
  `${PREFIX}/fetchR2Buckets`,
  async () => {
    const response = await watcherApi.get("/onesky/r2_files/buckets");
    return response.data;
  }
);

export const fetchR2Files = createAsyncThunk(
  `${PREFIX}/fetchR2Files`,
  async (params: { prefix?: string; bucket_id?: string; continuation_token?: string; limit?: number } = {}) => {
    const response = await watcherApi.get("/onesky/r2_files", { params });
    return response.data;
  }
);

export const deleteR2File = createAsyncThunk(
  `${PREFIX}/deleteR2File`,
  async ({ key, bucket_id }: { key: string; bucket_id?: string }) => {
    await watcherApi.delete("/onesky/r2_files", { params: { key, bucket_id } });
    return { key };
  }
);

export const createR2Folder = createAsyncThunk(
  `${PREFIX}/createR2Folder`,
  async ({ prefix, folder_name, bucket_id }: { prefix: string; folder_name: string; bucket_id?: string }, { rejectWithValue }) => {
    try {
      const response = await watcherApi.post("/onesky/r2_files/create_folder", { prefix, folder_name, bucket_id });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

export const renameR2Folder = createAsyncThunk(
  `${PREFIX}/renameR2Folder`,
  async ({ prefix, folder_name, bucket_id }: { prefix: string; folder_name: string; bucket_id?: string }, { rejectWithValue }) => {
    try {
      const response = await watcherApi.post("/onesky/r2_files/rename_folder", { prefix, folder_name, bucket_id });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

export const renameR2File = createAsyncThunk(
  `${PREFIX}/renameR2File`,
  async ({ key, filename, bucket_id }: { key: string; filename: string; bucket_id?: string }, { rejectWithValue }) => {
    try {
      const response = await watcherApi.post("/onesky/r2_files/rename_file", { key, filename, bucket_id });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

export const deleteR2Folder = createAsyncThunk(
  `${PREFIX}/deleteR2Folder`,
  async ({ prefix, bucket_id }: { prefix: string; bucket_id?: string }) => {
    await watcherApi.delete("/onesky/r2_files/destroy_folder", { params: { prefix, bucket_id } });
    return { prefix };
  }
);
